import { Stack } from "@mui/material";
import { useResizeObserverEffect } from "@root/utils/dom/useResizeObserver";
import { type Dispatch, type ReactNode, type SetStateAction, useRef } from "react";

export interface IStableSwitcherItemProps {
  value: string;
  children: ReactNode;
  active: string;
  setSize: Dispatch<SetStateAction<{ width: number; height: number }>>;
}

export const StableSwitcherItem = ({ value, children, active, setSize }: IStableSwitcherItemProps) => {
  const stackRef = useRef<HTMLDivElement>(null);

  useResizeObserverEffect(stackRef, (width, height) => {
    if (setSize) {
      setSize((prev) => {
        const maxWidth = Math.max(prev.width, width);
        const maxHeight = Math.max(prev.height, height);

        if (prev.width === maxWidth && prev.height === maxHeight) {
          return prev;
        }
        return { width: maxWidth, height: maxHeight };
      });
    }
  });

  return (
    <Stack
      ref={stackRef}
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        visibility: active === value ? "visible" : "hidden",
      }}
    >
      {children}
    </Stack>
  );
};
